import store from '../../../global-state/redux';
import { logoutUser as doLogout } from '../../../global-state/redux/actions';

const { dispatch } = store;

export const logoutUser = () => {
  dispatch(doLogout());
};
